import { render } from "./kcharts.vue?vue&type=template&id=4cf59ac0"
import script from "./kcharts.vue?vue&type=script&lang=js"
export * from "./kcharts.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/c7p4yP7J/0/platform/zhenwu/iot-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/kcharts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cf59ac0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cf59ac0', __exports__)) {
    console.log('reload')
    api.reload('4cf59ac0', __exports__)
  }
  
  module.hot.accept("./kcharts.vue?vue&type=template&id=4cf59ac0", () => {
    console.log('re-render')
    api.rerender('4cf59ac0', render)
  })

}


export default __exports__